import request from 'utils/request';

export default async function fetchGroups(): Promise<any> {
  try {
    const { data: result } = await request(
      `/lineDriveService/masterData/distributorRepMapper/groups
      `,
      {
        method: 'GET'
      }
    );

    return result;
  } catch (error) {
    console.log(error.message);
  }
}
